import "./TanklessWaterHeaterService.module.css";
import Header from "@/reusable_sections/Header";
import TanklessHero from "./sections/TanklessHero";
import TanklessServices from "./sections/TanklessServices";
import TanklessFaq from "./sections/TanklessFaq";
import Footer from "@/reusable_sections/Footer";
export default function TanklessWaterHeaterServicePage() {
  return <div>
      <Header />
      <TanklessHero />
      <TanklessServices />
      <TanklessFaq />
      <Footer />
    </div>;
}